import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';

import PatientGuideCmsAlignment, {
  CaregiverStatus,
} from 'common-src/models/PatientGuideCmsAlignment';

import { InfoItem } from 'src/components/elements';
import BasePopup from 'src/popups/BasePopup';

import styles from './AlignmentDetailsPopup.module.scss';

const AlignmentDetailsPopup = ({ alignment, onClose }) => (
  <BasePopup
    id="alignment-details"
    open
    onClose={onClose}
    title="Alignment Details"
    customStyle={{ minWidth: '50vw' }}
  >
    <div className={styles.grid}>
      <InfoItem
        title="Assessment Type"
        content={alignment.assessmentType}
        textId="assessment-type"
        small
      />
      <InfoItem
        title="Assessment Date"
        content={
          alignment.assessmentDate ? moment(alignment.assessmentDate).format('MM/DD/YYYY') : '-'
        }
        textId="assessment-date"
        small
      />
      <InfoItem title="Tier" content={alignment.tier} textId="tier" small />
      <InfoItem
        title="Existing Patient"
        content={
          typeof alignment.initialPatient === 'boolean'
            ? alignment.initialPatient
              ? 'Yes'
              : 'No'
            : '-'
        }
        textId="existing-patient"
        small
      />
      <InfoItem
        title="Referral Source"
        content={alignment.ptReferralSource}
        textId="referral-source"
        small
      />
      <InfoItem
        title="Caregiver Status"
        content={alignment.caregiverStatus}
        textId="caregiver-status"
        small
      />
      {alignment.caregiverStatus === CaregiverStatus.Other && (
        <InfoItem
          classNames={[styles.width100]}
          title="Other status specifics"
          content={alignment.caregiverStatusOs}
          textId="caregiver-status-os"
          small
        />
      )}
      <InfoItem
        title="Clinician Attestation"
        content={alignment.clinicianAttestation}
        textId="clinician-attestation"
        small
      />
      <InfoItem
        title="Nursing Home Status"
        content={alignment.nursingHomeStatus}
        textId="nursing-home-status"
        small
      />
      <InfoItem
        title="Residence Type"
        content={alignment.residenceType}
        textId="residence-type"
        small
      />
      <InfoItem
        title="Clinician First Name"
        content={alignment.clinicianFirstName}
        textId="clinician-first-name"
        small
      />
      <InfoItem
        title="Clinician Middle Name"
        content={alignment.clinicianMiddleName}
        textId="clinician-middle-name"
        small
      />
      <InfoItem
        title="Clinician Last Name"
        content={alignment.clinicianLastName}
        textId="clinician-last-name"
        small
      />
      <InfoItem title="NPI" content={alignment.npi} textId="npi" small />
      {alignment.reassessmentReason && (
        <InfoItem
          title="Re-assessment reason"
          content={alignment.reassessmentReason}
          textId="re-assessment-reason"
          small
        />
      )}
      {alignment.unalignmentReason && (
        <InfoItem
          title="Unalignment reason"
          content={alignment.unalignmentReason}
          textId="unalignment-reason"
          small
        />
      )}
      {alignment.unEffectiveDate && (
        <InfoItem
          title="Unalignment effective date"
          content={moment(alignment.unEffectiveDate).format('MM/DD/YYYY')}
          textId="unalignment-effective-date"
          small
        />
      )}
    </div>
    <div className={[styles.grid, 'primary-border-t'].join(' ')}>
      <InfoItem
        title="Last Updated"
        content={alignment.updatedAt ? moment(alignment.updatedAt).format('MM/DD/YYYY') : '-'}
        textId="last-updated"
        small
      />
      <InfoItem
        classNames={[styles.width75]}
        title="Last Updated By"
        content={alignment.updatedBy?.getName(true, false)}
        textId="updated-by"
        small
      />
    </div>
  </BasePopup>
);

AlignmentDetailsPopup.propTypes = {
  alignment: PropTypes.exact(PatientGuideCmsAlignment.schema),
  onClose: PropTypes.func,
};

export default AlignmentDetailsPopup;
